import React, { useState } from "react";
import { Badge, Button, FloatingLabel, Form } from "react-bootstrap";
import { useAuth } from "../../Context/AuthContext";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { httpClient } from "../../utils/HttpClient";
import PropTypes from "prop-types";

const CreateTemplate = ({ handleClose }) => {
  const Auth = useAuth();
  const [validated, setValidated] = useState(false);

  const [values, setValues] = useState({
    name: "",
    idtemplate: "",
  });

  const optimoveFields = [
    "MobilePhone",
    "Email",
    "AverageSportAmount",
    "Balance",
    "Email",
    "FirstName",
    "Gender",
    "LastName",
    "TotalBetAmount",
    "UserName",
    "RegistrationDate",
    "LifecycleStage",
    "MostEffectiveChannel",
    "PreferredCasinoGame",
    "PreferredSportsGame",
  ];

  const handleSubmit1 = (event) => {
    event.preventDefault();

    var userData = Auth.getSessionData();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      return;
    }

    setValidated(true);

    httpClient(
      "POST",
      ApiEndpoint + "partner/externaltemplate/" + userData.uid_partner,
      {
        name: values.name,
        message: values.message,
        idtemplate: values.idtemplate,
      },
      userData.token
    )
      .then(function (response) {
        console.log(response);
        handleClose();
        return;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const onChange = (event) => {
    const { name, value } = event.target;
    setValues({ ...values, [name]: value });
  };

  return (
    <>
      <Form noValidate validated={validated} onSubmit={handleSubmit1}>
        <h4>Crear Template Externo</h4>

        <hr />

        <FloatingLabel label="Nombre del Template" className="mb-3">
          <Form.Control
            type="text"
            name="name"
            id="name"
            value={values.name}
            required
            onChange={(event) => {
              onChange(event);
            }}
            placeholder="Ingrese un nombre valido"
          />
        </FloatingLabel>
        <FloatingLabel label="Mensaje" className="mb-3">
          <Form.Control
            as="textarea"
            name="message"
            style={{ height: "200px" }}
            id="message"
            value={values.message}
            required
            onChange={(event) => {
              onChange(event);
            }}
            placeholder="Ingrese el texto del mensaje"
          />
        </FloatingLabel>
        <hr />
        <div className="ShortLink" style={{ paddingTop: "10px" }}>
          <h6>
            Al darle click se agregará el campo personalizado correspondiente:
          </h6>
          <div className="AllLinks">
            <>
              {optimoveFields &&
                optimoveFields.map((field) => {
                  return (
                    <>
                      <Badge
                        onClick={() => {
                          //   setMessageText(field.vc_keycolumn);
                          setValues({
                            ...values,
                            message: values.message + " {" + field + "} ",
                          });
                        }}
                        bg="primary"
                      >
                        {field}
                      </Badge>
                    </>
                  );
                })}
            </>
          </div>
        </div>
        <div className="text-right">
          <Button variant="primary" type="submit" className="align-self-end">
            Guardar
          </Button>
        </div>
      </Form>
    </>
  );
};
CreateTemplate.propTypes = {
  handleClose: PropTypes.func.isRequired,
};
export default CreateTemplate;
